import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "settings-row" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { style: {"opacity":"0.5"} }, "%", -1)
const _hoisted_4 = {
  key: 0,
  class: "settings-row"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Dev Color", -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("span", _hoisted_2, _toDisplayString(_ctx.label), 1),
      _withDirectives(_createVNode("input", {
        type: "color",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.colorHex = $event)),
        onInput: _cache[2] || (_cache[2] = (...args) => (_ctx.updateColor(...args)))
      }, null, 544), [
        [_vModelText, _ctx.colorHex]
      ]),
      _withDirectives(_createVNode("input", {
        type: "text",
        style: {"max-width":"60px"},
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.colorHex = $event)),
        onInput: _cache[4] || (_cache[4] = (...args) => (_ctx.updateColor(...args)))
      }, null, 544), [
        [_vModelText, _ctx.colorHex]
      ]),
      _createVNode("input", {
        type: "number",
        style: {"max-width":"40px","text-align":"right"},
        value: _ctx.alpha * 100,
        onInput: _cache[5] || (_cache[5] = $event => {
        _ctx.alpha = Math.max(Math.min(Math.round($event.target.value) / 100, 1), 0);
        $event.target.value = _ctx.alpha * 100;
        _ctx.updateColor();
      })
      }, null, 40, ["value"]),
      _hoisted_3
    ]),
    (_ctx.devMode)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _hoisted_5,
          _createVNode("input", {
            type: "text",
            style: {"max-width":"157px"},
            value: _ctx.color,
            onInput: _cache[6] || (_cache[6] = $event => (_ctx.$emit('update:color', $event.target.value)))
          }, null, 40, ["value"])
        ]))
      : _createCommentVNode("", true)
  ], 64 /* STABLE_FRAGMENT */))
}